"use client";

import { DynamicLinkButton } from "@/components/common/dynamic-link-button/dynamic-link-button";
import ScreenLayout from "@/components/layout/screen-layout";
import Carousel, {
  Slider,
  SliderContainer,
  SliderDotButton
} from "@/components/ui/custom/carousel/carousel";
import { Testimonial_Review_Card_Stories_Devkrest, Text_Testimonial_Review_Card_Stories_Devkrest } from "@/lib/dto/home/stories-devkrest/stories-devkrest-data";
import { CardImgWinningHearts } from "@/lib/images";
import { EmblaOptionsType } from "embla-carousel";
import Image from "next/image";
// name change to TestimonialSection

// Set a longer delay for autoplay (5 seconds instead of default 3 seconds)
const OPTIONS: EmblaOptionsType = {
  loop: true,
  // The autoplay delay will be set to 5000ms (5 seconds) in the Carousel component
};

function TestimonialCardSectionStoriesDevkrest() {
  return (
    <ScreenLayout className="flex justify-center pt-7 md:pt-13">
      <div className="max-w-7xl bg-[linear-gradient(104.76deg,_#000929_0.42%,_#001F8F_99.58%)] text-white px-4 pb-4 pt-6 md:p-8 lg:p-16 rounded-3xl md:rounded-[20px] w-full">
        {/* Mobile and Desktop Layout */}
        <div className="flex-col justify-center lg:flex-row items-stretch gap-x-0 lg:gap-x-6.5 hidden lg:flex h-full">
          {/* Left image */}
          <div className="w-full lg:w-1/2 relative" style={{ minHeight: '100%' }}>
            <Image
              src={CardImgWinningHearts}
              alt="Dashboard Preview"
              className="rounded-2xl w-full h-full object-cover absolute inset-0"
              fill={true}
            />
          </div>

          {/* Right content */}
          <div className="flex flex-col justify-center w-full lg:w-1/2">
            <h2 className="text-start text-[32px] font-semibold">
              {Text_Testimonial_Review_Card_Stories_Devkrest.heading}
            </h2>
            <p className="text-sm md:text-base text-white opacity-80 text-center md:text-start pt-2.5 md:pt-5 pb-3 md:pb-4.5">
              {Text_Testimonial_Review_Card_Stories_Devkrest.sub_heading}
            </p>
            <DynamicLinkButton value="Explore more" href="/customer-success" variant="secondary" className="flex mx-0" />

            {/* Testimonial card */}
            <div className="flex flex-col bg-white/10 shadow-[0_24px_48px_rgba(21,26,40,0.05)] rounded-3xl p-6 mt-7.5 space-y-4 max-w-xl overflow-hidden">
              <Carousel
                options={OPTIONS}
                className="w-full"
                isAutoPlay={true}
              >
                <SliderContainer className="">
                  {Testimonial_Review_Card_Stories_Devkrest.map((v, i) => (
                    <Slider key={i} className="w-full px-1">
                      <div className="flex flex-col gap-4 p-2">
                        {/* Row 1: Client photo, name, flag, company */}
                        <div className="flex items-center justify-between gap-4">
                          <Image
                            src={v.img}
                            alt={v.name}
                            className="size-13 rounded-full object-cover border shadow-[0px_4px_10.2px_2px_rgba(255,255,255,0.12)] flex-shrink-0"
                          />
                          <div className="flex-1 min-w-0 mr-auto">
                            <div className="flex items-center gap-2 text-base font-semibold">
                              <p>{v.name}</p>
                              <Image
                                src={v.flag}
                                alt="USA"
                                className="size-5.5 object-cover"
                              />
                            </div>
                            <p className="text-sm font-medium text-white/70">
                              {v.company_name}
                            </p>
                          </div>
                          {/* <div className="flex-shrink-0 max-w-[80px] overflow-hidden">
                            <SliderDotButton className="flex-nowrap" />
                          </div> */}
                        </div>

                        {/* Row 2: Review text */}
                        <div className="w-full">
                          <p className="text-white/80 text-base font-normal italic break-words">
                            {v.review}
                          </p>
                        </div>
                      </div>
                    </Slider>
                  ))}
                </SliderContainer>
              </Carousel>
            </div>
          </div>
        </div>

        {/* Tablet Layout */}
        <div className="flex flex-col md:flex-row items-start gap-x-0 md:gap-x-6.5 gap-y-6 md:gap-y-0 lg:hidden">
          {/* Left image */}
          <div className="hidden md:block w-full md:w-1/2 h-full">
            <Image
              src={CardImgWinningHearts}
              alt="Dashboard Preview"
              className="rounded-2xl w-full"
            />
          </div>

          {/* Right content */}
          <div className="flex flex-col justify-center w-full md:w-1/2">
            <h2 className="text-center md:text-start text-xl sm:text-2xl md:text-[28px] font-semibold">
              {Text_Testimonial_Review_Card_Stories_Devkrest.heading}
            </h2>
            <p className="text-md md:text-lg text-white opacity-80 text-center md:text-start pt-4 md:pt-3 pb-4 md:pb-5">
              {Text_Testimonial_Review_Card_Stories_Devkrest.sub_heading}
            </p>
            <DynamicLinkButton value="Explore customer success stories" href="/customer-success" variant="secondary" className="flex mt-2 mx-auto md:mx-0" />
          </div>
        </div>

        {/* Testimonial card - full width on tablet */}
        <div className="flex flex-col w-full lg:hidden">
          <div className="flex flex-col bg-white/10 shadow-[0_24px_48px_rgba(21,26,40,0.05)] rounded-3xl p-4 md:p-6 mt-8 md:mt-7.5 space-y-4 max-w-full overflow-hidden">
            <Carousel
              options={OPTIONS}
              className="w-full"
              isAutoPlay={true}
            >
              <SliderContainer className="">
                {Testimonial_Review_Card_Stories_Devkrest.map((v, i) => (
                  <Slider key={i} className="w-full px-1">
                    <div className="flex flex-col gap-4 p-2">
                      {/* Row 1: Client photo, name, flag, company */}
                      <div className="flex items-center justify-between gap-4 flex-wrap sm:flex-nowrap">
                        <Image
                          src={v.img}
                          alt={v.name}
                          className="size-13 rounded-full object-cover border shadow-[0px_4px_10.2px_2px_rgba(255,255,255,0.12)] flex-shrink-0"
                        />
                        <div className="flex-1 min-w-0 mr-auto">
                          <div className="flex items-center gap-2 text-base font-semibold">
                            <p>{v.name}</p>
                            <Image
                              src={v.flag}
                              alt="USA"
                              className="size-5.5 object-cover"
                            />
                          </div>
                          <p className="text-md font-medium text-white/70">
                            {v.company_name}
                          </p>
                        </div>
                        <div className="flex-shrink-0 ml-auto mt-2 sm:mt-0 overflow-hidden hidden sm:block">
                          <SliderDotButton className="flex-nowrap" />
                        </div>
                      </div>

                      {/* Row 2: Review text */}
                      <div className="w-full">
                        <p className="text-white/80 text-base md:text-lg font-normal italic break-words">
                          {v.review}
                        </p>
                      </div>
                    </div>
                  </Slider>
                ))}
              </SliderContainer>
            </Carousel>
          </div>
        </div>
      </div>
    </ScreenLayout>
  );
}

export default TestimonialCardSectionStoriesDevkrest;
